/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ResetPasswordImport } from './routes/reset-password'
import { Route as ResetLinkSentImport } from './routes/reset-link-sent'
import { Route as RegistrationConfirmationImport } from './routes/registration-confirmation'
import { Route as RegisterImport } from './routes/register'
import { Route as PaymentCompleteImport } from './routes/payment-complete'
import { Route as LoginImport } from './routes/login'
import { Route as InteractiveExerciseImport } from './routes/interactive-exercise'
import { Route as ForgottenPasswordImport } from './routes/forgotten-password'
import { Route as CheckoutImport } from './routes/checkout'
import { Route as StudentImport } from './routes/_student'
import { Route as ParentOnboardingImport } from './routes/parent/onboarding'
import { Route as ParentAuthImport } from './routes/parent/_auth'
import { Route as InvitationTokenImport } from './routes/invitation.$token'
import { Route as AuthSuccessImport } from './routes/auth.success'
import { Route as StudentOnboardingImport } from './routes/_student/onboarding'
import { Route as StudentCommentsImport } from './routes/_student/comments'
import { Route as StudentLayoutImport } from './routes/_student/_layout'
import { Route as ParentAuthIndexImport } from './routes/parent/_auth/index'
import { Route as StudentLayoutIndexImport } from './routes/_student/_layout/index'
import { Route as ParentAuthSupportImport } from './routes/parent/_auth/support'
import { Route as ParentAuthSettingsImport } from './routes/parent/_auth/settings'
import { Route as StudentLayoutWaitingMessageImport } from './routes/_student/_layout/waiting-message'
import { Route as StudentLayoutSupportImport } from './routes/_student/_layout/support'
import { Route as StudentLayoutSettingsImport } from './routes/_student/_layout/settings'
import { Route as StudentLayoutProfileImport } from './routes/_student/_layout/profile'
import { Route as StudentLayoutPaymentsImport } from './routes/_student/_layout/payments'
import { Route as StudentLayoutInvoicesImport } from './routes/_student/_layout/invoices'
import { Route as StudentLayoutChangeSubscriptionImport } from './routes/_student/_layout/change-subscription'
import { Route as StudentLayoutBookCoursesImport } from './routes/_student/_layout/book-courses'
import { Route as StudentLayoutRessourcesIndexImport } from './routes/_student/_layout/ressources/index'
import { Route as StudentLayoutRessourcesGradeIndexImport } from './routes/_student/_layout/ressources/$grade/index'
import { Route as StudentLayoutRessourcesGradeSubjectIndexImport } from './routes/_student/_layout/ressources/$grade/$subject/index'
import { Route as StudentLayoutRessourcesGradeSubjectChapterIdQuizGeneralIndexImport } from './routes/_student/_layout/ressources/$grade/$subject/$chapterId/quiz-general/index'
import { Route as StudentLayoutRessourcesGradeSubjectChapterIdBilanIndexImport } from './routes/_student/_layout/ressources/$grade/$subject/$chapterId/bilan/index'
import { Route as StudentLayoutRessourcesGradeSubjectChapterIdSheetIdIndexImport } from './routes/_student/_layout/ressources/$grade/$subject/$chapterId/$sheetId/index'
import { Route as StudentLayoutRessourcesGradeSubjectChapterIdSheetIdQuizIndexImport } from './routes/_student/_layout/ressources/$grade/$subject/$chapterId/$sheetId/quiz/index'

// Create Virtual Routes

const ParentImport = createFileRoute('/parent')()
const StudentMeetingSlotIdLazyImport = createFileRoute(
  '/_student/meeting/$slot-id',
)()

// Create/Update Routes

const ParentRoute = ParentImport.update({
  id: '/parent',
  path: '/parent',
  getParentRoute: () => rootRoute,
} as any)

const ResetPasswordRoute = ResetPasswordImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRoute,
} as any)

const ResetLinkSentRoute = ResetLinkSentImport.update({
  id: '/reset-link-sent',
  path: '/reset-link-sent',
  getParentRoute: () => rootRoute,
} as any)

const RegistrationConfirmationRoute = RegistrationConfirmationImport.update({
  id: '/registration-confirmation',
  path: '/registration-confirmation',
  getParentRoute: () => rootRoute,
} as any)

const RegisterRoute = RegisterImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRoute,
} as any)

const PaymentCompleteRoute = PaymentCompleteImport.update({
  id: '/payment-complete',
  path: '/payment-complete',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const InteractiveExerciseRoute = InteractiveExerciseImport.update({
  id: '/interactive-exercise',
  path: '/interactive-exercise',
  getParentRoute: () => rootRoute,
} as any)

const ForgottenPasswordRoute = ForgottenPasswordImport.update({
  id: '/forgotten-password',
  path: '/forgotten-password',
  getParentRoute: () => rootRoute,
} as any)

const CheckoutRoute = CheckoutImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => rootRoute,
} as any)

const StudentRoute = StudentImport.update({
  id: '/_student',
  getParentRoute: () => rootRoute,
} as any)

const ParentOnboardingRoute = ParentOnboardingImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => ParentRoute,
} as any)

const ParentAuthRoute = ParentAuthImport.update({
  id: '/_auth',
  getParentRoute: () => ParentRoute,
} as any)

const InvitationTokenRoute = InvitationTokenImport.update({
  id: '/invitation/$token',
  path: '/invitation/$token',
  getParentRoute: () => rootRoute,
} as any)

const AuthSuccessRoute = AuthSuccessImport.update({
  id: '/auth/success',
  path: '/auth/success',
  getParentRoute: () => rootRoute,
} as any)

const StudentOnboardingRoute = StudentOnboardingImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => StudentRoute,
} as any)

const StudentCommentsRoute = StudentCommentsImport.update({
  id: '/comments',
  path: '/comments',
  getParentRoute: () => StudentRoute,
} as any)

const StudentLayoutRoute = StudentLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StudentRoute,
} as any)

const ParentAuthIndexRoute = ParentAuthIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ParentAuthRoute,
} as any)

const StudentLayoutIndexRoute = StudentLayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StudentLayoutRoute,
} as any)

const StudentMeetingSlotIdLazyRoute = StudentMeetingSlotIdLazyImport.update({
  id: '/meeting/$slot-id',
  path: '/meeting/$slot-id',
  getParentRoute: () => StudentRoute,
} as any).lazy(() =>
  import('./routes/_student/meeting/$slot-id.lazy').then((d) => d.Route),
)

const ParentAuthSupportRoute = ParentAuthSupportImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => ParentAuthRoute,
} as any)

const ParentAuthSettingsRoute = ParentAuthSettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => ParentAuthRoute,
} as any)

const StudentLayoutWaitingMessageRoute =
  StudentLayoutWaitingMessageImport.update({
    id: '/waiting-message',
    path: '/waiting-message',
    getParentRoute: () => StudentLayoutRoute,
  } as any)

const StudentLayoutSupportRoute = StudentLayoutSupportImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => StudentLayoutRoute,
} as any)

const StudentLayoutSettingsRoute = StudentLayoutSettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => StudentLayoutRoute,
} as any)

const StudentLayoutProfileRoute = StudentLayoutProfileImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => StudentLayoutRoute,
} as any)

const StudentLayoutPaymentsRoute = StudentLayoutPaymentsImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => StudentLayoutRoute,
} as any)

const StudentLayoutInvoicesRoute = StudentLayoutInvoicesImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => StudentLayoutRoute,
} as any)

const StudentLayoutChangeSubscriptionRoute =
  StudentLayoutChangeSubscriptionImport.update({
    id: '/change-subscription',
    path: '/change-subscription',
    getParentRoute: () => StudentLayoutRoute,
  } as any)

const StudentLayoutBookCoursesRoute = StudentLayoutBookCoursesImport.update({
  id: '/book-courses',
  path: '/book-courses',
  getParentRoute: () => StudentLayoutRoute,
} as any)

const StudentLayoutRessourcesIndexRoute =
  StudentLayoutRessourcesIndexImport.update({
    id: '/ressources/',
    path: '/ressources/',
    getParentRoute: () => StudentLayoutRoute,
  } as any)

const StudentLayoutRessourcesGradeIndexRoute =
  StudentLayoutRessourcesGradeIndexImport.update({
    id: '/ressources/$grade/',
    path: '/ressources/$grade/',
    getParentRoute: () => StudentLayoutRoute,
  } as any)

const StudentLayoutRessourcesGradeSubjectIndexRoute =
  StudentLayoutRessourcesGradeSubjectIndexImport.update({
    id: '/ressources/$grade/$subject/',
    path: '/ressources/$grade/$subject/',
    getParentRoute: () => StudentLayoutRoute,
  } as any)

const StudentLayoutRessourcesGradeSubjectChapterIdQuizGeneralIndexRoute =
  StudentLayoutRessourcesGradeSubjectChapterIdQuizGeneralIndexImport.update({
    id: '/ressources/$grade/$subject/$chapterId/quiz-general/',
    path: '/ressources/$grade/$subject/$chapterId/quiz-general/',
    getParentRoute: () => StudentLayoutRoute,
  } as any)

const StudentLayoutRessourcesGradeSubjectChapterIdBilanIndexRoute =
  StudentLayoutRessourcesGradeSubjectChapterIdBilanIndexImport.update({
    id: '/ressources/$grade/$subject/$chapterId/bilan/',
    path: '/ressources/$grade/$subject/$chapterId/bilan/',
    getParentRoute: () => StudentLayoutRoute,
  } as any)

const StudentLayoutRessourcesGradeSubjectChapterIdSheetIdIndexRoute =
  StudentLayoutRessourcesGradeSubjectChapterIdSheetIdIndexImport.update({
    id: '/ressources/$grade/$subject/$chapterId/$sheetId/',
    path: '/ressources/$grade/$subject/$chapterId/$sheetId/',
    getParentRoute: () => StudentLayoutRoute,
  } as any)

const StudentLayoutRessourcesGradeSubjectChapterIdSheetIdQuizIndexRoute =
  StudentLayoutRessourcesGradeSubjectChapterIdSheetIdQuizIndexImport.update({
    id: '/ressources/$grade/$subject/$chapterId/$sheetId/quiz/',
    path: '/ressources/$grade/$subject/$chapterId/$sheetId/quiz/',
    getParentRoute: () => StudentLayoutRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_student': {
      id: '/_student'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof StudentImport
      parentRoute: typeof rootRoute
    }
    '/checkout': {
      id: '/checkout'
      path: '/checkout'
      fullPath: '/checkout'
      preLoaderRoute: typeof CheckoutImport
      parentRoute: typeof rootRoute
    }
    '/forgotten-password': {
      id: '/forgotten-password'
      path: '/forgotten-password'
      fullPath: '/forgotten-password'
      preLoaderRoute: typeof ForgottenPasswordImport
      parentRoute: typeof rootRoute
    }
    '/interactive-exercise': {
      id: '/interactive-exercise'
      path: '/interactive-exercise'
      fullPath: '/interactive-exercise'
      preLoaderRoute: typeof InteractiveExerciseImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/payment-complete': {
      id: '/payment-complete'
      path: '/payment-complete'
      fullPath: '/payment-complete'
      preLoaderRoute: typeof PaymentCompleteImport
      parentRoute: typeof rootRoute
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterImport
      parentRoute: typeof rootRoute
    }
    '/registration-confirmation': {
      id: '/registration-confirmation'
      path: '/registration-confirmation'
      fullPath: '/registration-confirmation'
      preLoaderRoute: typeof RegistrationConfirmationImport
      parentRoute: typeof rootRoute
    }
    '/reset-link-sent': {
      id: '/reset-link-sent'
      path: '/reset-link-sent'
      fullPath: '/reset-link-sent'
      preLoaderRoute: typeof ResetLinkSentImport
      parentRoute: typeof rootRoute
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/_student/_layout': {
      id: '/_student/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof StudentLayoutImport
      parentRoute: typeof StudentImport
    }
    '/_student/comments': {
      id: '/_student/comments'
      path: '/comments'
      fullPath: '/comments'
      preLoaderRoute: typeof StudentCommentsImport
      parentRoute: typeof StudentImport
    }
    '/_student/onboarding': {
      id: '/_student/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof StudentOnboardingImport
      parentRoute: typeof StudentImport
    }
    '/auth/success': {
      id: '/auth/success'
      path: '/auth/success'
      fullPath: '/auth/success'
      preLoaderRoute: typeof AuthSuccessImport
      parentRoute: typeof rootRoute
    }
    '/invitation/$token': {
      id: '/invitation/$token'
      path: '/invitation/$token'
      fullPath: '/invitation/$token'
      preLoaderRoute: typeof InvitationTokenImport
      parentRoute: typeof rootRoute
    }
    '/parent': {
      id: '/parent'
      path: '/parent'
      fullPath: '/parent'
      preLoaderRoute: typeof ParentImport
      parentRoute: typeof rootRoute
    }
    '/parent/_auth': {
      id: '/parent/_auth'
      path: '/parent'
      fullPath: '/parent'
      preLoaderRoute: typeof ParentAuthImport
      parentRoute: typeof ParentRoute
    }
    '/parent/onboarding': {
      id: '/parent/onboarding'
      path: '/onboarding'
      fullPath: '/parent/onboarding'
      preLoaderRoute: typeof ParentOnboardingImport
      parentRoute: typeof ParentImport
    }
    '/_student/_layout/book-courses': {
      id: '/_student/_layout/book-courses'
      path: '/book-courses'
      fullPath: '/book-courses'
      preLoaderRoute: typeof StudentLayoutBookCoursesImport
      parentRoute: typeof StudentLayoutImport
    }
    '/_student/_layout/change-subscription': {
      id: '/_student/_layout/change-subscription'
      path: '/change-subscription'
      fullPath: '/change-subscription'
      preLoaderRoute: typeof StudentLayoutChangeSubscriptionImport
      parentRoute: typeof StudentLayoutImport
    }
    '/_student/_layout/invoices': {
      id: '/_student/_layout/invoices'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof StudentLayoutInvoicesImport
      parentRoute: typeof StudentLayoutImport
    }
    '/_student/_layout/payments': {
      id: '/_student/_layout/payments'
      path: '/payments'
      fullPath: '/payments'
      preLoaderRoute: typeof StudentLayoutPaymentsImport
      parentRoute: typeof StudentLayoutImport
    }
    '/_student/_layout/profile': {
      id: '/_student/_layout/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof StudentLayoutProfileImport
      parentRoute: typeof StudentLayoutImport
    }
    '/_student/_layout/settings': {
      id: '/_student/_layout/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof StudentLayoutSettingsImport
      parentRoute: typeof StudentLayoutImport
    }
    '/_student/_layout/support': {
      id: '/_student/_layout/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof StudentLayoutSupportImport
      parentRoute: typeof StudentLayoutImport
    }
    '/_student/_layout/waiting-message': {
      id: '/_student/_layout/waiting-message'
      path: '/waiting-message'
      fullPath: '/waiting-message'
      preLoaderRoute: typeof StudentLayoutWaitingMessageImport
      parentRoute: typeof StudentLayoutImport
    }
    '/parent/_auth/settings': {
      id: '/parent/_auth/settings'
      path: '/settings'
      fullPath: '/parent/settings'
      preLoaderRoute: typeof ParentAuthSettingsImport
      parentRoute: typeof ParentAuthImport
    }
    '/parent/_auth/support': {
      id: '/parent/_auth/support'
      path: '/support'
      fullPath: '/parent/support'
      preLoaderRoute: typeof ParentAuthSupportImport
      parentRoute: typeof ParentAuthImport
    }
    '/_student/meeting/$slot-id': {
      id: '/_student/meeting/$slot-id'
      path: '/meeting/$slot-id'
      fullPath: '/meeting/$slot-id'
      preLoaderRoute: typeof StudentMeetingSlotIdLazyImport
      parentRoute: typeof StudentImport
    }
    '/_student/_layout/': {
      id: '/_student/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof StudentLayoutIndexImport
      parentRoute: typeof StudentLayoutImport
    }
    '/parent/_auth/': {
      id: '/parent/_auth/'
      path: '/'
      fullPath: '/parent/'
      preLoaderRoute: typeof ParentAuthIndexImport
      parentRoute: typeof ParentAuthImport
    }
    '/_student/_layout/ressources/': {
      id: '/_student/_layout/ressources/'
      path: '/ressources'
      fullPath: '/ressources'
      preLoaderRoute: typeof StudentLayoutRessourcesIndexImport
      parentRoute: typeof StudentLayoutImport
    }
    '/_student/_layout/ressources/$grade/': {
      id: '/_student/_layout/ressources/$grade/'
      path: '/ressources/$grade'
      fullPath: '/ressources/$grade'
      preLoaderRoute: typeof StudentLayoutRessourcesGradeIndexImport
      parentRoute: typeof StudentLayoutImport
    }
    '/_student/_layout/ressources/$grade/$subject/': {
      id: '/_student/_layout/ressources/$grade/$subject/'
      path: '/ressources/$grade/$subject'
      fullPath: '/ressources/$grade/$subject'
      preLoaderRoute: typeof StudentLayoutRessourcesGradeSubjectIndexImport
      parentRoute: typeof StudentLayoutImport
    }
    '/_student/_layout/ressources/$grade/$subject/$chapterId/$sheetId/': {
      id: '/_student/_layout/ressources/$grade/$subject/$chapterId/$sheetId/'
      path: '/ressources/$grade/$subject/$chapterId/$sheetId'
      fullPath: '/ressources/$grade/$subject/$chapterId/$sheetId'
      preLoaderRoute: typeof StudentLayoutRessourcesGradeSubjectChapterIdSheetIdIndexImport
      parentRoute: typeof StudentLayoutImport
    }
    '/_student/_layout/ressources/$grade/$subject/$chapterId/bilan/': {
      id: '/_student/_layout/ressources/$grade/$subject/$chapterId/bilan/'
      path: '/ressources/$grade/$subject/$chapterId/bilan'
      fullPath: '/ressources/$grade/$subject/$chapterId/bilan'
      preLoaderRoute: typeof StudentLayoutRessourcesGradeSubjectChapterIdBilanIndexImport
      parentRoute: typeof StudentLayoutImport
    }
    '/_student/_layout/ressources/$grade/$subject/$chapterId/quiz-general/': {
      id: '/_student/_layout/ressources/$grade/$subject/$chapterId/quiz-general/'
      path: '/ressources/$grade/$subject/$chapterId/quiz-general'
      fullPath: '/ressources/$grade/$subject/$chapterId/quiz-general'
      preLoaderRoute: typeof StudentLayoutRessourcesGradeSubjectChapterIdQuizGeneralIndexImport
      parentRoute: typeof StudentLayoutImport
    }
    '/_student/_layout/ressources/$grade/$subject/$chapterId/$sheetId/quiz/': {
      id: '/_student/_layout/ressources/$grade/$subject/$chapterId/$sheetId/quiz/'
      path: '/ressources/$grade/$subject/$chapterId/$sheetId/quiz'
      fullPath: '/ressources/$grade/$subject/$chapterId/$sheetId/quiz'
      preLoaderRoute: typeof StudentLayoutRessourcesGradeSubjectChapterIdSheetIdQuizIndexImport
      parentRoute: typeof StudentLayoutImport
    }
  }
}

// Create and export the route tree

interface StudentLayoutRouteChildren {
  StudentLayoutBookCoursesRoute: typeof StudentLayoutBookCoursesRoute
  StudentLayoutChangeSubscriptionRoute: typeof StudentLayoutChangeSubscriptionRoute
  StudentLayoutInvoicesRoute: typeof StudentLayoutInvoicesRoute
  StudentLayoutPaymentsRoute: typeof StudentLayoutPaymentsRoute
  StudentLayoutProfileRoute: typeof StudentLayoutProfileRoute
  StudentLayoutSettingsRoute: typeof StudentLayoutSettingsRoute
  StudentLayoutSupportRoute: typeof StudentLayoutSupportRoute
  StudentLayoutWaitingMessageRoute: typeof StudentLayoutWaitingMessageRoute
  StudentLayoutIndexRoute: typeof StudentLayoutIndexRoute
  StudentLayoutRessourcesIndexRoute: typeof StudentLayoutRessourcesIndexRoute
  StudentLayoutRessourcesGradeIndexRoute: typeof StudentLayoutRessourcesGradeIndexRoute
  StudentLayoutRessourcesGradeSubjectIndexRoute: typeof StudentLayoutRessourcesGradeSubjectIndexRoute
  StudentLayoutRessourcesGradeSubjectChapterIdSheetIdIndexRoute: typeof StudentLayoutRessourcesGradeSubjectChapterIdSheetIdIndexRoute
  StudentLayoutRessourcesGradeSubjectChapterIdBilanIndexRoute: typeof StudentLayoutRessourcesGradeSubjectChapterIdBilanIndexRoute
  StudentLayoutRessourcesGradeSubjectChapterIdQuizGeneralIndexRoute: typeof StudentLayoutRessourcesGradeSubjectChapterIdQuizGeneralIndexRoute
  StudentLayoutRessourcesGradeSubjectChapterIdSheetIdQuizIndexRoute: typeof StudentLayoutRessourcesGradeSubjectChapterIdSheetIdQuizIndexRoute
}

const StudentLayoutRouteChildren: StudentLayoutRouteChildren = {
  StudentLayoutBookCoursesRoute: StudentLayoutBookCoursesRoute,
  StudentLayoutChangeSubscriptionRoute: StudentLayoutChangeSubscriptionRoute,
  StudentLayoutInvoicesRoute: StudentLayoutInvoicesRoute,
  StudentLayoutPaymentsRoute: StudentLayoutPaymentsRoute,
  StudentLayoutProfileRoute: StudentLayoutProfileRoute,
  StudentLayoutSettingsRoute: StudentLayoutSettingsRoute,
  StudentLayoutSupportRoute: StudentLayoutSupportRoute,
  StudentLayoutWaitingMessageRoute: StudentLayoutWaitingMessageRoute,
  StudentLayoutIndexRoute: StudentLayoutIndexRoute,
  StudentLayoutRessourcesIndexRoute: StudentLayoutRessourcesIndexRoute,
  StudentLayoutRessourcesGradeIndexRoute:
    StudentLayoutRessourcesGradeIndexRoute,
  StudentLayoutRessourcesGradeSubjectIndexRoute:
    StudentLayoutRessourcesGradeSubjectIndexRoute,
  StudentLayoutRessourcesGradeSubjectChapterIdSheetIdIndexRoute:
    StudentLayoutRessourcesGradeSubjectChapterIdSheetIdIndexRoute,
  StudentLayoutRessourcesGradeSubjectChapterIdBilanIndexRoute:
    StudentLayoutRessourcesGradeSubjectChapterIdBilanIndexRoute,
  StudentLayoutRessourcesGradeSubjectChapterIdQuizGeneralIndexRoute:
    StudentLayoutRessourcesGradeSubjectChapterIdQuizGeneralIndexRoute,
  StudentLayoutRessourcesGradeSubjectChapterIdSheetIdQuizIndexRoute:
    StudentLayoutRessourcesGradeSubjectChapterIdSheetIdQuizIndexRoute,
}

const StudentLayoutRouteWithChildren = StudentLayoutRoute._addFileChildren(
  StudentLayoutRouteChildren,
)

interface StudentRouteChildren {
  StudentLayoutRoute: typeof StudentLayoutRouteWithChildren
  StudentCommentsRoute: typeof StudentCommentsRoute
  StudentOnboardingRoute: typeof StudentOnboardingRoute
  StudentMeetingSlotIdLazyRoute: typeof StudentMeetingSlotIdLazyRoute
}

const StudentRouteChildren: StudentRouteChildren = {
  StudentLayoutRoute: StudentLayoutRouteWithChildren,
  StudentCommentsRoute: StudentCommentsRoute,
  StudentOnboardingRoute: StudentOnboardingRoute,
  StudentMeetingSlotIdLazyRoute: StudentMeetingSlotIdLazyRoute,
}

const StudentRouteWithChildren =
  StudentRoute._addFileChildren(StudentRouteChildren)

interface ParentAuthRouteChildren {
  ParentAuthSettingsRoute: typeof ParentAuthSettingsRoute
  ParentAuthSupportRoute: typeof ParentAuthSupportRoute
  ParentAuthIndexRoute: typeof ParentAuthIndexRoute
}

const ParentAuthRouteChildren: ParentAuthRouteChildren = {
  ParentAuthSettingsRoute: ParentAuthSettingsRoute,
  ParentAuthSupportRoute: ParentAuthSupportRoute,
  ParentAuthIndexRoute: ParentAuthIndexRoute,
}

const ParentAuthRouteWithChildren = ParentAuthRoute._addFileChildren(
  ParentAuthRouteChildren,
)

interface ParentRouteChildren {
  ParentAuthRoute: typeof ParentAuthRouteWithChildren
  ParentOnboardingRoute: typeof ParentOnboardingRoute
}

const ParentRouteChildren: ParentRouteChildren = {
  ParentAuthRoute: ParentAuthRouteWithChildren,
  ParentOnboardingRoute: ParentOnboardingRoute,
}

const ParentRouteWithChildren =
  ParentRoute._addFileChildren(ParentRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof StudentLayoutRouteWithChildren
  '/checkout': typeof CheckoutRoute
  '/forgotten-password': typeof ForgottenPasswordRoute
  '/interactive-exercise': typeof InteractiveExerciseRoute
  '/login': typeof LoginRoute
  '/payment-complete': typeof PaymentCompleteRoute
  '/register': typeof RegisterRoute
  '/registration-confirmation': typeof RegistrationConfirmationRoute
  '/reset-link-sent': typeof ResetLinkSentRoute
  '/reset-password': typeof ResetPasswordRoute
  '/comments': typeof StudentCommentsRoute
  '/onboarding': typeof StudentOnboardingRoute
  '/auth/success': typeof AuthSuccessRoute
  '/invitation/$token': typeof InvitationTokenRoute
  '/parent': typeof ParentAuthRouteWithChildren
  '/parent/onboarding': typeof ParentOnboardingRoute
  '/book-courses': typeof StudentLayoutBookCoursesRoute
  '/change-subscription': typeof StudentLayoutChangeSubscriptionRoute
  '/invoices': typeof StudentLayoutInvoicesRoute
  '/payments': typeof StudentLayoutPaymentsRoute
  '/profile': typeof StudentLayoutProfileRoute
  '/settings': typeof StudentLayoutSettingsRoute
  '/support': typeof StudentLayoutSupportRoute
  '/waiting-message': typeof StudentLayoutWaitingMessageRoute
  '/parent/settings': typeof ParentAuthSettingsRoute
  '/parent/support': typeof ParentAuthSupportRoute
  '/meeting/$slot-id': typeof StudentMeetingSlotIdLazyRoute
  '/': typeof StudentLayoutIndexRoute
  '/parent/': typeof ParentAuthIndexRoute
  '/ressources': typeof StudentLayoutRessourcesIndexRoute
  '/ressources/$grade': typeof StudentLayoutRessourcesGradeIndexRoute
  '/ressources/$grade/$subject': typeof StudentLayoutRessourcesGradeSubjectIndexRoute
  '/ressources/$grade/$subject/$chapterId/$sheetId': typeof StudentLayoutRessourcesGradeSubjectChapterIdSheetIdIndexRoute
  '/ressources/$grade/$subject/$chapterId/bilan': typeof StudentLayoutRessourcesGradeSubjectChapterIdBilanIndexRoute
  '/ressources/$grade/$subject/$chapterId/quiz-general': typeof StudentLayoutRessourcesGradeSubjectChapterIdQuizGeneralIndexRoute
  '/ressources/$grade/$subject/$chapterId/$sheetId/quiz': typeof StudentLayoutRessourcesGradeSubjectChapterIdSheetIdQuizIndexRoute
}

export interface FileRoutesByTo {
  '': typeof StudentRouteWithChildren
  '/checkout': typeof CheckoutRoute
  '/forgotten-password': typeof ForgottenPasswordRoute
  '/interactive-exercise': typeof InteractiveExerciseRoute
  '/login': typeof LoginRoute
  '/payment-complete': typeof PaymentCompleteRoute
  '/register': typeof RegisterRoute
  '/registration-confirmation': typeof RegistrationConfirmationRoute
  '/reset-link-sent': typeof ResetLinkSentRoute
  '/reset-password': typeof ResetPasswordRoute
  '/comments': typeof StudentCommentsRoute
  '/onboarding': typeof StudentOnboardingRoute
  '/auth/success': typeof AuthSuccessRoute
  '/invitation/$token': typeof InvitationTokenRoute
  '/parent': typeof ParentAuthIndexRoute
  '/parent/onboarding': typeof ParentOnboardingRoute
  '/book-courses': typeof StudentLayoutBookCoursesRoute
  '/change-subscription': typeof StudentLayoutChangeSubscriptionRoute
  '/invoices': typeof StudentLayoutInvoicesRoute
  '/payments': typeof StudentLayoutPaymentsRoute
  '/profile': typeof StudentLayoutProfileRoute
  '/settings': typeof StudentLayoutSettingsRoute
  '/support': typeof StudentLayoutSupportRoute
  '/waiting-message': typeof StudentLayoutWaitingMessageRoute
  '/parent/settings': typeof ParentAuthSettingsRoute
  '/parent/support': typeof ParentAuthSupportRoute
  '/meeting/$slot-id': typeof StudentMeetingSlotIdLazyRoute
  '/': typeof StudentLayoutIndexRoute
  '/ressources': typeof StudentLayoutRessourcesIndexRoute
  '/ressources/$grade': typeof StudentLayoutRessourcesGradeIndexRoute
  '/ressources/$grade/$subject': typeof StudentLayoutRessourcesGradeSubjectIndexRoute
  '/ressources/$grade/$subject/$chapterId/$sheetId': typeof StudentLayoutRessourcesGradeSubjectChapterIdSheetIdIndexRoute
  '/ressources/$grade/$subject/$chapterId/bilan': typeof StudentLayoutRessourcesGradeSubjectChapterIdBilanIndexRoute
  '/ressources/$grade/$subject/$chapterId/quiz-general': typeof StudentLayoutRessourcesGradeSubjectChapterIdQuizGeneralIndexRoute
  '/ressources/$grade/$subject/$chapterId/$sheetId/quiz': typeof StudentLayoutRessourcesGradeSubjectChapterIdSheetIdQuizIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_student': typeof StudentRouteWithChildren
  '/checkout': typeof CheckoutRoute
  '/forgotten-password': typeof ForgottenPasswordRoute
  '/interactive-exercise': typeof InteractiveExerciseRoute
  '/login': typeof LoginRoute
  '/payment-complete': typeof PaymentCompleteRoute
  '/register': typeof RegisterRoute
  '/registration-confirmation': typeof RegistrationConfirmationRoute
  '/reset-link-sent': typeof ResetLinkSentRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_student/_layout': typeof StudentLayoutRouteWithChildren
  '/_student/comments': typeof StudentCommentsRoute
  '/_student/onboarding': typeof StudentOnboardingRoute
  '/auth/success': typeof AuthSuccessRoute
  '/invitation/$token': typeof InvitationTokenRoute
  '/parent': typeof ParentRouteWithChildren
  '/parent/_auth': typeof ParentAuthRouteWithChildren
  '/parent/onboarding': typeof ParentOnboardingRoute
  '/_student/_layout/book-courses': typeof StudentLayoutBookCoursesRoute
  '/_student/_layout/change-subscription': typeof StudentLayoutChangeSubscriptionRoute
  '/_student/_layout/invoices': typeof StudentLayoutInvoicesRoute
  '/_student/_layout/payments': typeof StudentLayoutPaymentsRoute
  '/_student/_layout/profile': typeof StudentLayoutProfileRoute
  '/_student/_layout/settings': typeof StudentLayoutSettingsRoute
  '/_student/_layout/support': typeof StudentLayoutSupportRoute
  '/_student/_layout/waiting-message': typeof StudentLayoutWaitingMessageRoute
  '/parent/_auth/settings': typeof ParentAuthSettingsRoute
  '/parent/_auth/support': typeof ParentAuthSupportRoute
  '/_student/meeting/$slot-id': typeof StudentMeetingSlotIdLazyRoute
  '/_student/_layout/': typeof StudentLayoutIndexRoute
  '/parent/_auth/': typeof ParentAuthIndexRoute
  '/_student/_layout/ressources/': typeof StudentLayoutRessourcesIndexRoute
  '/_student/_layout/ressources/$grade/': typeof StudentLayoutRessourcesGradeIndexRoute
  '/_student/_layout/ressources/$grade/$subject/': typeof StudentLayoutRessourcesGradeSubjectIndexRoute
  '/_student/_layout/ressources/$grade/$subject/$chapterId/$sheetId/': typeof StudentLayoutRessourcesGradeSubjectChapterIdSheetIdIndexRoute
  '/_student/_layout/ressources/$grade/$subject/$chapterId/bilan/': typeof StudentLayoutRessourcesGradeSubjectChapterIdBilanIndexRoute
  '/_student/_layout/ressources/$grade/$subject/$chapterId/quiz-general/': typeof StudentLayoutRessourcesGradeSubjectChapterIdQuizGeneralIndexRoute
  '/_student/_layout/ressources/$grade/$subject/$chapterId/$sheetId/quiz/': typeof StudentLayoutRessourcesGradeSubjectChapterIdSheetIdQuizIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/checkout'
    | '/forgotten-password'
    | '/interactive-exercise'
    | '/login'
    | '/payment-complete'
    | '/register'
    | '/registration-confirmation'
    | '/reset-link-sent'
    | '/reset-password'
    | '/comments'
    | '/onboarding'
    | '/auth/success'
    | '/invitation/$token'
    | '/parent'
    | '/parent/onboarding'
    | '/book-courses'
    | '/change-subscription'
    | '/invoices'
    | '/payments'
    | '/profile'
    | '/settings'
    | '/support'
    | '/waiting-message'
    | '/parent/settings'
    | '/parent/support'
    | '/meeting/$slot-id'
    | '/'
    | '/parent/'
    | '/ressources'
    | '/ressources/$grade'
    | '/ressources/$grade/$subject'
    | '/ressources/$grade/$subject/$chapterId/$sheetId'
    | '/ressources/$grade/$subject/$chapterId/bilan'
    | '/ressources/$grade/$subject/$chapterId/quiz-general'
    | '/ressources/$grade/$subject/$chapterId/$sheetId/quiz'
  fileRoutesByTo: FileRoutesByTo
  to:
    | ''
    | '/checkout'
    | '/forgotten-password'
    | '/interactive-exercise'
    | '/login'
    | '/payment-complete'
    | '/register'
    | '/registration-confirmation'
    | '/reset-link-sent'
    | '/reset-password'
    | '/comments'
    | '/onboarding'
    | '/auth/success'
    | '/invitation/$token'
    | '/parent'
    | '/parent/onboarding'
    | '/book-courses'
    | '/change-subscription'
    | '/invoices'
    | '/payments'
    | '/profile'
    | '/settings'
    | '/support'
    | '/waiting-message'
    | '/parent/settings'
    | '/parent/support'
    | '/meeting/$slot-id'
    | '/'
    | '/ressources'
    | '/ressources/$grade'
    | '/ressources/$grade/$subject'
    | '/ressources/$grade/$subject/$chapterId/$sheetId'
    | '/ressources/$grade/$subject/$chapterId/bilan'
    | '/ressources/$grade/$subject/$chapterId/quiz-general'
    | '/ressources/$grade/$subject/$chapterId/$sheetId/quiz'
  id:
    | '__root__'
    | '/_student'
    | '/checkout'
    | '/forgotten-password'
    | '/interactive-exercise'
    | '/login'
    | '/payment-complete'
    | '/register'
    | '/registration-confirmation'
    | '/reset-link-sent'
    | '/reset-password'
    | '/_student/_layout'
    | '/_student/comments'
    | '/_student/onboarding'
    | '/auth/success'
    | '/invitation/$token'
    | '/parent'
    | '/parent/_auth'
    | '/parent/onboarding'
    | '/_student/_layout/book-courses'
    | '/_student/_layout/change-subscription'
    | '/_student/_layout/invoices'
    | '/_student/_layout/payments'
    | '/_student/_layout/profile'
    | '/_student/_layout/settings'
    | '/_student/_layout/support'
    | '/_student/_layout/waiting-message'
    | '/parent/_auth/settings'
    | '/parent/_auth/support'
    | '/_student/meeting/$slot-id'
    | '/_student/_layout/'
    | '/parent/_auth/'
    | '/_student/_layout/ressources/'
    | '/_student/_layout/ressources/$grade/'
    | '/_student/_layout/ressources/$grade/$subject/'
    | '/_student/_layout/ressources/$grade/$subject/$chapterId/$sheetId/'
    | '/_student/_layout/ressources/$grade/$subject/$chapterId/bilan/'
    | '/_student/_layout/ressources/$grade/$subject/$chapterId/quiz-general/'
    | '/_student/_layout/ressources/$grade/$subject/$chapterId/$sheetId/quiz/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  StudentRoute: typeof StudentRouteWithChildren
  CheckoutRoute: typeof CheckoutRoute
  ForgottenPasswordRoute: typeof ForgottenPasswordRoute
  InteractiveExerciseRoute: typeof InteractiveExerciseRoute
  LoginRoute: typeof LoginRoute
  PaymentCompleteRoute: typeof PaymentCompleteRoute
  RegisterRoute: typeof RegisterRoute
  RegistrationConfirmationRoute: typeof RegistrationConfirmationRoute
  ResetLinkSentRoute: typeof ResetLinkSentRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  AuthSuccessRoute: typeof AuthSuccessRoute
  InvitationTokenRoute: typeof InvitationTokenRoute
  ParentRoute: typeof ParentRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  StudentRoute: StudentRouteWithChildren,
  CheckoutRoute: CheckoutRoute,
  ForgottenPasswordRoute: ForgottenPasswordRoute,
  InteractiveExerciseRoute: InteractiveExerciseRoute,
  LoginRoute: LoginRoute,
  PaymentCompleteRoute: PaymentCompleteRoute,
  RegisterRoute: RegisterRoute,
  RegistrationConfirmationRoute: RegistrationConfirmationRoute,
  ResetLinkSentRoute: ResetLinkSentRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  AuthSuccessRoute: AuthSuccessRoute,
  InvitationTokenRoute: InvitationTokenRoute,
  ParentRoute: ParentRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_student",
        "/checkout",
        "/forgotten-password",
        "/interactive-exercise",
        "/login",
        "/payment-complete",
        "/register",
        "/registration-confirmation",
        "/reset-link-sent",
        "/reset-password",
        "/auth/success",
        "/invitation/$token",
        "/parent"
      ]
    },
    "/_student": {
      "filePath": "_student.tsx",
      "children": [
        "/_student/_layout",
        "/_student/comments",
        "/_student/onboarding",
        "/_student/meeting/$slot-id"
      ]
    },
    "/checkout": {
      "filePath": "checkout.tsx"
    },
    "/forgotten-password": {
      "filePath": "forgotten-password.tsx"
    },
    "/interactive-exercise": {
      "filePath": "interactive-exercise.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/payment-complete": {
      "filePath": "payment-complete.tsx"
    },
    "/register": {
      "filePath": "register.tsx"
    },
    "/registration-confirmation": {
      "filePath": "registration-confirmation.tsx"
    },
    "/reset-link-sent": {
      "filePath": "reset-link-sent.tsx"
    },
    "/reset-password": {
      "filePath": "reset-password.tsx"
    },
    "/_student/_layout": {
      "filePath": "_student/_layout.tsx",
      "parent": "/_student",
      "children": [
        "/_student/_layout/book-courses",
        "/_student/_layout/change-subscription",
        "/_student/_layout/invoices",
        "/_student/_layout/payments",
        "/_student/_layout/profile",
        "/_student/_layout/settings",
        "/_student/_layout/support",
        "/_student/_layout/waiting-message",
        "/_student/_layout/",
        "/_student/_layout/ressources/",
        "/_student/_layout/ressources/$grade/",
        "/_student/_layout/ressources/$grade/$subject/",
        "/_student/_layout/ressources/$grade/$subject/$chapterId/$sheetId/",
        "/_student/_layout/ressources/$grade/$subject/$chapterId/bilan/",
        "/_student/_layout/ressources/$grade/$subject/$chapterId/quiz-general/",
        "/_student/_layout/ressources/$grade/$subject/$chapterId/$sheetId/quiz/"
      ]
    },
    "/_student/comments": {
      "filePath": "_student/comments.tsx",
      "parent": "/_student"
    },
    "/_student/onboarding": {
      "filePath": "_student/onboarding.tsx",
      "parent": "/_student"
    },
    "/auth/success": {
      "filePath": "auth.success.tsx"
    },
    "/invitation/$token": {
      "filePath": "invitation.$token.tsx"
    },
    "/parent": {
      "filePath": "parent",
      "children": [
        "/parent/_auth",
        "/parent/onboarding"
      ]
    },
    "/parent/_auth": {
      "filePath": "parent/_auth.tsx",
      "parent": "/parent",
      "children": [
        "/parent/_auth/settings",
        "/parent/_auth/support",
        "/parent/_auth/"
      ]
    },
    "/parent/onboarding": {
      "filePath": "parent/onboarding.tsx",
      "parent": "/parent"
    },
    "/_student/_layout/book-courses": {
      "filePath": "_student/_layout/book-courses.tsx",
      "parent": "/_student/_layout"
    },
    "/_student/_layout/change-subscription": {
      "filePath": "_student/_layout/change-subscription.tsx",
      "parent": "/_student/_layout"
    },
    "/_student/_layout/invoices": {
      "filePath": "_student/_layout/invoices.tsx",
      "parent": "/_student/_layout"
    },
    "/_student/_layout/payments": {
      "filePath": "_student/_layout/payments.tsx",
      "parent": "/_student/_layout"
    },
    "/_student/_layout/profile": {
      "filePath": "_student/_layout/profile.tsx",
      "parent": "/_student/_layout"
    },
    "/_student/_layout/settings": {
      "filePath": "_student/_layout/settings.tsx",
      "parent": "/_student/_layout"
    },
    "/_student/_layout/support": {
      "filePath": "_student/_layout/support.tsx",
      "parent": "/_student/_layout"
    },
    "/_student/_layout/waiting-message": {
      "filePath": "_student/_layout/waiting-message.tsx",
      "parent": "/_student/_layout"
    },
    "/parent/_auth/settings": {
      "filePath": "parent/_auth/settings.tsx",
      "parent": "/parent/_auth"
    },
    "/parent/_auth/support": {
      "filePath": "parent/_auth/support.tsx",
      "parent": "/parent/_auth"
    },
    "/_student/meeting/$slot-id": {
      "filePath": "_student/meeting/$slot-id.lazy.tsx",
      "parent": "/_student"
    },
    "/_student/_layout/": {
      "filePath": "_student/_layout/index.tsx",
      "parent": "/_student/_layout"
    },
    "/parent/_auth/": {
      "filePath": "parent/_auth/index.tsx",
      "parent": "/parent/_auth"
    },
    "/_student/_layout/ressources/": {
      "filePath": "_student/_layout/ressources/index.tsx",
      "parent": "/_student/_layout"
    },
    "/_student/_layout/ressources/$grade/": {
      "filePath": "_student/_layout/ressources/$grade/index.tsx",
      "parent": "/_student/_layout"
    },
    "/_student/_layout/ressources/$grade/$subject/": {
      "filePath": "_student/_layout/ressources/$grade/$subject/index.tsx",
      "parent": "/_student/_layout"
    },
    "/_student/_layout/ressources/$grade/$subject/$chapterId/$sheetId/": {
      "filePath": "_student/_layout/ressources/$grade/$subject/$chapterId/$sheetId/index.tsx",
      "parent": "/_student/_layout"
    },
    "/_student/_layout/ressources/$grade/$subject/$chapterId/bilan/": {
      "filePath": "_student/_layout/ressources/$grade/$subject/$chapterId/bilan/index.tsx",
      "parent": "/_student/_layout"
    },
    "/_student/_layout/ressources/$grade/$subject/$chapterId/quiz-general/": {
      "filePath": "_student/_layout/ressources/$grade/$subject/$chapterId/quiz-general/index.tsx",
      "parent": "/_student/_layout"
    },
    "/_student/_layout/ressources/$grade/$subject/$chapterId/$sheetId/quiz/": {
      "filePath": "_student/_layout/ressources/$grade/$subject/$chapterId/$sheetId/quiz/index.tsx",
      "parent": "/_student/_layout"
    }
  }
}
ROUTE_MANIFEST_END */
